import { LanguageProvider, useLanguage } from '@/contexts/LanguageContext';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import WhyNowSection from '@/components/WhyNowSection';
import StorySection from '@/components/StorySection';
import EarlyTractionSection from '@/components/EarlyTractionSection';
import AgentsGridSection from '@/components/AgentsGridSection';
import FlowchartSection from '@/components/FlowchartSection';
import SafetySection from '@/components/SafetySection';
import FeaturesSection from '@/components/FeaturesSection';
import ScientificVisibilitySection from '@/components/ScientificVisibilitySection';
import PlatformSection from '@/components/PlatformSection';
import FinalCTASection from '@/components/FinalCTASection';
import Footer from '@/components/Footer';

function useScrollDepth(page: string) {
  useEffect(() => {
    let fired = false;
    const onScroll = () => {
      if (fired) return;
      const scrolled = window.scrollY + window.innerHeight;
      const total = document.documentElement.scrollHeight;
      if (total > 0 && scrolled / total >= 0.5) {
        fired = true;
        trackEvent('scroll_50_percent', { page });
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [page]);
}

function PageContent() {
  const { lang } = useLanguage();
  useDocumentMeta(lang);
  useScrollDepth('home');

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <WhyNowSection />
        <AgentsGridSection />
        <StorySection />
        <EarlyTractionSection />
        <FlowchartSection />
        <SafetySection />
        <FeaturesSection />
        <ScientificVisibilitySection />
        <PlatformSection />
        <FinalCTASection />
      </main>
      <Footer />
    </>
  );
}

const Index = () => {
  return (
    <LanguageProvider>
      <PageContent />
    </LanguageProvider>
  );
};

export default Index;
